import { render, staticRenderFns } from "./MediaTraffic.vue?vue&type=template&id=4f9e8a4f&scoped=true&"
import script from "./MediaTraffic.vue?vue&type=script&lang=ts&"
export * from "./MediaTraffic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e8a4f",
  null
  
)

export default component.exports